import styled from 'styled-components';

import { CloseButton } from '#src/atoms/buttons/CloseButton/index.tsx';
import { SBHorizontal } from '#src/atoms/layout/flex/index.tsx';
import { BackButton } from '#src/components/dialog/BackButton/index.tsx';

const Root = styled(SBHorizontal)`
  width: 100%;
`;

type Props = {
  onClose?: () => void;
  onBack?: () => void;
};

export const Header = ({ onClose, onBack }: Props) => {
  return (
    <Root>
      <div>{!!onBack && <BackButton onBack={onBack} />}</div>
      <div>{!!onClose && <CloseButton size="medium" onClose={onClose} />}</div>
    </Root>
  );
};
